import type { Highlight } from '@/modules/Entertainment/interface/Program';
import type { FC } from 'react';
import Link from 'next/link';
import { Flex, Text } from '@eqi-investimentos/react';
import { Box, Image } from '@chakra-ui/react';
import { PATHS } from '@/config/paths';
import { IfRender } from '@/utils/jsx';

export const MostViewedCard: FC<MostViewedCardProps> = ({
  programType,
  slug,
  thumb,
  title,
  type,
  category,
  hideCategory = false,
}) => {
  return (
    <Flex
      as={Link}
      href={getCardHref({ type, programType, slug })}
      passHref
      flexDir="row"
      w="21.75rem"
      maxW="21.75rem"
      h="7.75rem"
      p="l"
      gap="s"
      bg="background.brandLight"
      borderRadius="0.5rem"
      transition="0.3s all ease-in-out"
      _hover={{ bg: 'action.hover.brandLight' }}
    >
      <Box w="5.25rem" h="5.25rem">
        <Image
          src={thumb}
          alt={title}
          w="5.25rem"
          h="5.25rem"
          objectFit="cover"
          borderRadius="lg"
        />
      </Box>
      <Flex
        flexDir="column"
        alignItems="left"
        w="full"
        paddingTop="2"
        maxW="13.25rem"
        gap="8"
      >
        <IfRender condition={!hideCategory}>
          <Text fontSize="l" fontWeight="medium" color="content.brand">
            {category}
          </Text>
        </IfRender>
        <Text fontSize="xl" color="content.primary" noOfLines={2}>
          {title}
        </Text>
      </Flex>
    </Flex>
  );
};

const getCardHref = ({
  programType,
  slug,
  type,
}: {
  type: Highlight['type'];
  programType: Highlight['program_type'];
  slug: string;
}) => {
  if (type === 'content') {
    return `${PATHS.hubs.content}/${slug}`;
  }
  if (programType === 'recommendation') {
    return `${PATHS.hubs.researchProgram}/${slug}`;
  }
  return `${PATHS.hubs[type]}/${slug}`;
};

type MostViewedCardProps = Pick<Highlight, 'thumb' | 'title' | 'type'> & {
  programType: Highlight['program_type'];
  slug: Highlight['id'];
  category?: string;
  type?: string;
  hideCategory?: boolean;
};
